import { StyleSheet } from "react-native"
import { color } from "../../theme"

export const styles = StyleSheet.create({
  hidden: {
    opacity: 0,
  },
  iconStyle: {
    alignSelf: "center",
  },
  main: {
    flex: 1,
    flexDirection: "row",
  },
  radioButtonLabel: {
    alignSelf: "center",
    color: color.text,
    fontSize: 18,
    marginLeft: 10,
  },
})

export const viewPresets = {
  circle: Object.assign({}, {
    color: color.primary,
    size: 24,
  }),
  square: Object.assign({}, {
    color: color.primaryIcon,
    size: 28,
  }),
}

export type RadioButtonPresets = keyof typeof viewPresets
